import { EMPTY_LIST } from '../../../../../constants/common'
import { RentalPortalApplicantsBoardCard } from '../RentalPortalApplicantsBoardCard'

import { ApplicantsBoardColumnContentState } from './RentalPortalApplicantsBoardColumn.constants'
import { RentalPortalApplicantsBoardColumnEmpty } from './RentalPortalApplicantsBoardColumnEmpty'
import { RentalPortalApplicantsBoardColumnSkeleton } from './RentalPortalApplicantsBoardColumnSkeleton'

function getApplicantsBoardColumnContentState({ isLoading, items }) {
  return isLoading
    ? ApplicantsBoardColumnContentState.Loading
    : items.length > 0
      ? ApplicantsBoardColumnContentState.Cards
      : ApplicantsBoardColumnContentState.Empty
}

export function getApplicantsBoardColumnState(column) {
  const items = column?.items ?? EMPTY_LIST
  const total = column?.total ?? 0

  return { hiddenCount: total - items.length, items, total }
}

export function getHasApplicantsBoardColumnMore(hiddenCount) {
  return hiddenCount > 0
}

export function getApplicantsBoardColumnContent({
  isLoading,
  items,
  onClickCard,
  onMouseDownCard,
}) {
  switch (getApplicantsBoardColumnContentState({ isLoading, items })) {
    case ApplicantsBoardColumnContentState.Loading:
      return <RentalPortalApplicantsBoardColumnSkeleton />
    case ApplicantsBoardColumnContentState.Cards:
      return items.map(item => (
        <RentalPortalApplicantsBoardCard
          item={item}
          key={item.id}
          onClick={onClickCard}
          onMouseDown={onMouseDownCard}
        />
      ))
    case ApplicantsBoardColumnContentState.Empty:
      return <RentalPortalApplicantsBoardColumnEmpty />
    default:
      return null
  }
}
